import {
  formatCurrency,
  getSeatAdditionalLabel,
} from '../../../../../utilities/helpers'

import Button from 'react-bootstrap/Button'

import { QuickpickBadge } from '../../../NewSeatedPurchaseWrapper/NewSeatedPurchaseContainer/TicketSelectionPanel/ListingsContainer/TicketGroup/TicketGroup'
import DetailsButton from '../../DetailsButton/DetailsButton'
import accessibleIcon from '../../../../../assets/icons/accessible.png'
import useSeatmapStore from '../../../../../stores/seatmapStore'

import './selectedTicket.scss'

export default function SelectedTicket({
  ticketGroup,
  toggleView,
  processingFeePerTicket = 0,
  showProcessingFee = false,
  isSeasonPackage = false,
  showBaseTicketPrice = false,
}) {
  // Zustand
  const unselectSeat = useSeatmapStore((state) => state.unselectSeat)
  const seatmapData = useSeatmapStore((state) => state.data)

  const { price } = ticketGroup
  const offer =
    ticketGroup?.offer || ticketGroup?.package || ticketGroup?.listing?.offer
  const ticketPriceWithFees =
    ticketGroup?.ticketCostWithFeesAndTax ??
    ticketGroup?.ticketCostWithFees ??
    ticketGroup?.totalDue ??
    price
  const ticketPriceWithFeesAndProcessing =
    ticketPriceWithFees + (Number(processingFeePerTicket) || 0)
  const displayPrice = offer?.freeOffer
    ? 0
    : showBaseTicketPrice
      ? price
      : isSeasonPackage || showProcessingFee
        ? ticketPriceWithFeesAndProcessing
        : ticketPriceWithFees
  let offerName
  let inventoryType

  if (!Boolean(ticketGroup?.listing)) {
    offerName = offer?.name
    inventoryType = offer?.inventoryType
  }

  const getAccessibleLabel = (accessibleType) => {
    if (accessibleType === 'DA') return 'Accessible: Open space for wheelchair'
    if (accessibleType === 'DB') return 'Accessible: Chair-back seating'
    return 'Accessible seating'
  }

  const mapSeat = ticketGroup?.seatId
    ? seatmapData?.seats?.[ticketGroup.seatId]
    : null
  const accessibleType =
    mapSeat?.accessibleType ||
    mapSeat?.accessiblityType ||
    mapSeat?.accessibilityType ||
    ticketGroup?.accessibleType ||
    ticketGroup?.accessiblityType ||
    ticketGroup?.accessibilityType
  const isAccessible =
    Boolean(accessibleType) ||
    Boolean(mapSeat?.accessible || ticketGroup?.accessible)
  const accessibleLabel = isAccessible
    ? getAccessibleLabel(accessibleType)
    : null
  const additionalLabel = getSeatAdditionalLabel({
    mapSeat,
    ticketGroup,
    seatLabels: seatmapData?.seatLabels,
  })

  return (
    <div className="vjx-yy">
      <Button variant="outline-light" className="vjx-btn">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => unselectSeat(ticketGroup?.seatId, ticketGroup)}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.97652 3.97554C4.21083 3.74123 4.59073 3.74123 4.82505 3.97554L8.00078 7.15128L11.1765 3.97554C11.4108 3.74123 11.7907 3.74123 12.025 3.97554C12.2594 4.20986 12.2594 4.58975 12.025 4.82407L8.84931 7.9998L12.025 11.1755C12.2594 11.4099 12.2594 11.7898 12.025 12.0241C11.7907 12.2584 11.4108 12.2584 11.1765 12.0241L8.00078 8.84833L4.82505 12.0241C4.59073 12.2584 4.21083 12.2584 3.97652 12.0241C3.7422 11.7898 3.7422 11.4099 3.97652 11.1755L7.15225 7.9998L3.97652 4.82407C3.7422 4.58975 3.7422 4.20986 3.97652 3.97554Z"
            fill="#23262F"
          />
        </svg>
      </Button>
      <div className="vjx-yt">
        <div className="vjx-ytt">
          {ticketGroup.GA ? (
            <span className="vjx-pos1">{ticketGroup?.sectionName}</span>
          ) : (
            <>
              <Position segment={'SEC'} position={ticketGroup?.sectionNumber} />
              <Position segment={'ROW'} position={ticketGroup?.rowNumber} />
              <Position segment={'SEAT'} position={ticketGroup?.seatNumber} />
            </>
          )}
        </div>
        <div className="vjx-ytr">
          <span className="vjx-ytp">{formatCurrency(displayPrice)}</span>
          <span className="vjx-yti">
            {offer?.freeOffer
              ? 'Complimentary'
              : showBaseTicketPrice
                ? 'Ticket price'
                : 'Incl. Taxes & Fees'}
          </span>
        </div>
      </div>
      <div className="vjx-yb">
        <QuickpickBadge
          isListing={Boolean(ticketGroup?.listing)}
          listing={ticketGroup?.listing}
          inventoryType={inventoryType}
          offerName={offerName}
        />
        <div className="vjx-ybb">
          <DetailsButton
            text="Details"
            onClick={() => toggleView(ticketGroup, ticketGroup?.seatId)}
          />
        </div>
      </div>
      {accessibleLabel && (
        <div className="vjx-yb-accessible">
          <img src={accessibleIcon} alt="" aria-hidden="true" />
          <span>{accessibleLabel}</span>
        </div>
      )}
      {additionalLabel && (
        <div className="vjx-yb-additional">{additionalLabel}</div>
      )}
    </div>
  )
}

function Position({ segment, position }) {
  return (
    <div className="vjx-pos">
      <span className="vjx-pos1">{segment}</span>
      <span className="vjx-pos2">{position}</span>
    </div>
  )
}
